import axiosInstance from '../../../core/api/axios';

const getLessonDetailsById = async (id: string) => {
  const response = await axiosInstance.get(`/lessons/by-id/${id}`);
  return response.data;
};

export default getLessonDetailsById;
